// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
const { formatCount, pluralize } = require('shared/string-utils')
// Common client-V2 imports
const tag = require('client-v2/common/utils/hyperscript')
const { UserFollowCircleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { registerComponentEventHandlers } = require('client-v2/common/components/utils')
const { userProfileHref } = require('client-v2/common/models/user/actions')
const UserModelRecord = require('client-v2/common/models/user/record')
const PageContextRecord = require('client-v2/common/models/page-context/record')

const bem = BemEntity('UserCard')

const Followers = pluralize('Follower')

class UserCard extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerComponentEventHandlers(this)
  }

  // Linkage methods

  userHref() {
    if (this.props.isHrefsEnabled) {
      return userProfileHref(this.props.user)
    }
  }

  // Render methods

  renderBio() {
    const { user } = this.props
    let { bio } = user
    if (!bio && user.mixesBio) {
      bio = `Posts in ${user.mixesBio}`
    }
    if (!bio) {
      return null
    }
    return (
      tag('div', {
        className: bem.element('bio'),
        title: bio
      },
        bio
      )
    )
  }

  renderDisplayName() {
    const displayName = this.props.user['display_name']
    return (
      tag('div', {
        className: bem.element('display-name'),
        title: displayName
      },
        displayName
      )
    )
  }

  renderFollowButton() {
    if (this.props.isSelf || !this.props.onFollowClick) {
      return null
    }
    const { isFollowing } = this.props.user
    return (
      tag(UserFollowCircleButton, {
        className: bem.element('follow-button'),
        checked: isFollowing,
        onClick: this.onFollowClick
      })
    )
  }

  renderFollowerCount() {
    const count = this.props.user['follower_count']
    let text = null
    if (this.props.isFollowerCountVisible && count > 0) {
      text = `${formatCount(count)} ${Followers(count)}`
    }
    return tag('div', {
      className: bem.element('follower-count')
    },
      text
    )
  }

  renderHeaderImage() {
    const headerImages = this.props.user['header_image_urls']
    if (!headerImages) {
      return null
    }
    return tag(LazyImage, {
      className: bem.element('header-image'),
      sources: [headerImages.small]
    })
  }

  renderUserName() {
    const userName = `@${this.props.user.username}`
    return (
      tag('div', {
        className: bem.element('user-name'),
        title: userName
      },
        userName
      )
    )
  }

  renderUserPhoto() {
    return tag(UserAvatar, {
      className: bem.element('user-photo'),
      user: this.props.user
    })
  }

  render() {
    return (
      // Lockup wrapper
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block({
            interactive: !!this.props.onCardClick,
            self: this.props.isSelf
          })
        ),
        dataset: {
          userId: this.props.user.id
        },
        onClick: this.onCardClick
      },
        tag('a', {
          className: bem.element('inner'),
          href: this.userHref()
        },
          this.renderHeaderImage(),
          this.renderUserPhoto(),
          this.renderUserName(),
          this.renderDisplayName(),
          this.renderBio(),
          this.renderFollowerCount(),
          this.renderFollowButton()
        )
      )
    )
  }
}

UserCard.propTypes = {
  // Flags
  isFollowerCountVisible: PropTypes.bool,
  isHrefsEnabled: PropTypes.bool,
  isSelf: PropTypes.bool,
  // Values
  className: PropTypes.string,
  pageContext: PropTypes.shape(PageContextRecord.propTypes),
  user: PropTypes.shape(UserModelRecord.propTypes),
  // Callbacks used as props
  onCardClick: PropTypes.func,
  onFollowClick: PropTypes.func
}

UserCard.eventHandlerKeys = [
  'onCardClick',
  'onFollowClick'
]

UserCard.defaultProps = {
  // Flags
  isFollowerCountVisible: true,
  isHrefsEnabled: true,
  isSelf: false
}

module.exports = UserCard
